const styles = {
  date: {
    marginRight: '8px',
  },
  hyphen: {
    marginRight: '8px',
    marginLeft: '8px',
  },
  dateBlock: {
    display: 'flex',
    alignItems: 'center',
    color: 'kit.text.main',
  },
  main: {
    display: 'flex',
    alignItems: 'center',
    '&:first-child': {
      marginRight: '27px',
    },
  },
  adaptive: {
    display: 'flex',
    alignItems: {
      xs: 'flex-start',
      lg: 'center',
    },
    flexDirection: {
      xs: 'column',
      lg: 'row',
    },
    '& .date': {
      display: {
        xs: 'block',
        lg: 'inline',
      },
      marginBottom: {
        xs: '8px',
        lg: '0',
      },
    },
    '& .description': {
      fontSize: '14px',
    },
  },
};

export default styles;
